import { Component } from "react";
import Api from "entities/helpers/api";
import PropTypes from "prop-types";
import _ from "underscore";

import EverTrue from "app";

class ReminderDataContainer extends Component {
  static propTypes = {
    render: PropTypes.func,
  };

  static defaultProps = {
    render: () => {},
  };

  state = {
    reminders: [],
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchReminder = task_id => {
    Api.UGC.REMINDERS.get({
      urlExtend: "/reminders",
      params: {
        task_id: task_id,
      },
    }).then(reminders => {
      this.mounted &&
        this.setState({
          reminders,
        });
    });
  };

  createReminder = reminder => {
    EverTrue.track.set("todo_action", { type: "reminder_create" });
    return Api.UGC.REMINDERS.post({
      data: _.jsonStringify(reminder),
    }).then(reminder_res => {
      this.fetchReminder(reminder_res.task_id);
      return reminder_res;
    });
  };

  editReminder = reminder => {
    EverTrue.track.set("todo_action", { type: "reminder_edit" });
    return Api.UGC.REMINDERS.put({
      urlExtend: `/${reminder.id}`,
      data: _.jsonStringify({
        remind_at: reminder.remind_at,
      }),
    }).then(reminder => {
      this.fetchReminder(reminder.task_id);
      return reminder;
    });
  };
  deleteReminder = (reminder_id, task_id) => {
    EverTrue.track.set("todo_action", { type: "reminder_delete" });
    return Api.UGC.REMINDERS.delete({
      urlExtend: `/${reminder_id}`,
    }).then(() => {
      this.alertWithMessage("Reminder deleted successfully");
      this.fetchReminder(task_id);
    });
  };

  alertWithMessage = msg => {
    EverTrue.Alert.success(<div>{msg}</div>);
  };

  failureWithMessage = msg => {
    EverTrue.Alert.error(<div>{msg}</div>);
  };

  render() {
    return this.props.render({
      reminders: this.state.reminders,
      createReminder: this.createReminder,
      deleteReminder: this.deleteReminder,
      fetchReminder: this.fetchReminder,
      editReminder: this.editReminder,
    });
  }
}

export default ReminderDataContainer;
